export default __webpack_public_path__ + "media/images/images/elements/11-3c5188544cc3b4d2aa2460462887631b.png";